module.exports = __webpack_public_path__ + "static/assets/90567f9170b22a30c1bd9d0d2e51a022.jpg";